/**
 * Converti date/heure serveur UTC en heure de Madagascar.
 * Format final : 12/12/2025 à 08:27
 */
const formatDateTimeMadagascar = (serverDateTime) => {
    if (!serverDateTime || serverDateTime === "0000-00-00") {
        return "";
    }

   
    const utcString = serverDateTime.replace(" ", "T") + "Z";
    const dateObject = new Date(utcString);

    const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: "Indian/Antananarivo"
    };

    return dateObject
        .toLocaleString("fr-FR", options)
        .replace(" ", " à ");
};

export default formatDateTimeMadagascar;
